import { render } from "./size-guide-tables.vue?vue&type=template&id=d0d970c0"
import script from "./size-guide-tables.vue?vue&type=script&lang=js"
export * from "./size-guide-tables.vue?vue&type=script&lang=js"

import "./size-guide-tables.vue?vue&type=style&index=0&id=d0d970c0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__